<slick-dialog #dialogRef header="Business Development Account" [width]="800">
	<div *ngIf="businessDevelopmentAccount">
		<div class="mb-2">
			<label for="bdAccountName">Account Name</label>
			<input
				id="bdAccountName"
				type="text"
				class="form-control"
				[(ngModel)]="businessDevelopmentAccount.contact.companyName"
				[slick-validation-indicator]="businessDevelopmentAccount.contact.companyName"
				slickValidationType="error" />
		</div>

		<div class="d-flex mb-2">
			<div class="w-50 me-1">
				<label>Account Type</label>
				<div class="d-flex">
					<div class="flex-fill me-1">
						<slick-drop-down (onSelect)="onAccountTypeChanged($event)" [items]="accountTypes" [ngModel]="businessDevelopmentAccount.businessDevelopmentAccountTypeId"> </slick-drop-down>
					</div>
					<div>
						<button class="btn btn-outline-primary" (click)="editAccountTypes()"><i class="far fa-pencil text-primary"></i></button>
					</div>
				</div>
			</div>
			<div class="w-50">
				<label>Marketing Rep</label>
				<slick-drop-down [items]="marketingEmployees" [ngModel]="businessDevelopmentAccount.marketingEmployeeId" (onSelect)="onMarketingEmployeeChanged($event)" placeholder="None"></slick-drop-down>
			</div>
		</div>

		<div class="mb-2" *ngIf="isGazingleCompany">
			<label>Gazingle Referral Type</label>
			<slick-drop-down [items]="gazingleRefTypes" [ngModel]="businessDevelopmentAccount.gazingleRefTypeId" (onSelect)="onGazingleRefTypeChanged($event)" placeholder="None"></slick-drop-down>
		</div>

		<div style="line-height: 1.2rem">
			<input type="checkbox" [checked]="businessDevelopmentAccount.isReferral" (change)="onIsReferralChanged()" />Referral<br />
			<input type="checkbox" [checked]="businessDevelopmentAccount.isCarrier" (change)="onIsCarrierChanged()" />Carrier<br />
		</div>

		<contact-edit #contactEditRef [contactModel]="businessDevelopmentAccount.contact" hideFirstAndLastName="true" hideCompanyName="true" showQuickbooksName="false" showButtons="false"></contact-edit>

		<input type="checkbox" [(ngModel)]="businessDevelopmentAccount.isActive" />Active<br />
	</div>

	<slick-dialog-footer>
		<button type="button" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary save-button" (click)="onSave()"><i class="far fa-save"></i>&nbsp;Save</button>
		<button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancel()"><i class="far fa-ban"></i>&nbsp;Cancel</button>
	</slick-dialog-footer>
</slick-dialog>

<business-development-account-types-dialog #businessDevelopmentAccountTypesDialog></business-development-account-types-dialog>
